import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  type_warmUp: {
    color: theme.palette.success.main,
    backgroundColor: theme.palette.successSamitransparent,
  },
  type_normal: {
    color: theme.palette.font.secondary,
    backgroundColor: theme.palette.secondary.main,
  },
  type_failure: {
    color: theme.palette.warning.main,
    backgroundColor: theme.palette.warningSamitransparent,
  },
  type_drop: {
    color: theme.palette.error.main,
    backgroundColor: theme.palette.errorSamitransparent,
  },
  typeIcon: {
    fontSize: '0.85rem',
    lineHeight: '0.85rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: theme.spacing(3.5),
    maxWidth: theme.spacing(3.5),
    height: theme.spacing(3.5),
    borderRadius: '10px',
  },
}));
